import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, Select, TextField } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import LuxonUtils from '@date-io/luxon';
import { dateUtcToS } from '../../../util/dateUtil';
import { HOUSING_PLAN_OPTIONS } from '../../../constants/general';

const Edu = ({ form, setForm, classes, disabled }) => {
  // Determine suffix based on postGradPlan
  // const suffix = form.postGradPlan === '4-Year College' ? '4Year' : form.postGradPlan === '2-Year College' ? '2Year' : 'CareerTraining';
  // Helper to get the field name for the plan
  // const field = (base) => `${base}${suffix}`;
  const field = (base) => `${base}`;
  return (
    <>
      <Grid container direction="row" alignItems="center" className={classes.unprintedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>ACT Score:</label>
        </Grid>
        <Grid item xs={12} md={6} className={classes.textRowSpacer} style={{ marginTop: 8, marginBottom: 8 }}>
          <FormControl>
            <TextField
              id="act"
              size="small"
              hiddenLabel
              placeholder="ACT Score"
              variant="outlined"
              value={form[field('actScore')] || form.actScore}
              onChange={(event) => setForm({ ...form, [field('actScore')]: event.target.value })}
              inputProps={{ maxLength: 50, classes: { input: classes.textField } }}
              disabled={disabled}
            />
          </FormControl>
        </Grid>
        <Grid item xs={false} md={3} lg={false} />
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>ACT Test Date:</label>
        </Grid>
        <Grid item xs={12} md={6} className={classes.rowSpacer} style={{ marginTop: 8, marginBottom: 8 }}>
          {!disabled ? (
            <MuiPickersUtilsProvider utils={LuxonUtils}>
              <KeyboardDatePicker
                autoOk
                variant="inline"
                id="act-date"
                disableFuture
                hiddenLabel
                value={form[field('actDate')] || null}
                onChange={(date) => {
                  setForm({ ...form, [field('actDate')]: date ? date : null });
                }}
                format="MM/dd/yyyy"
                className={classes.datepicker}
                disabled={disabled}
                style={{ width: '23%' }}
              />
            </MuiPickersUtilsProvider>
          ) : (
            <summary style={{ marginTop: 3 }} className={classes.subtleBold}>
              {dateUtcToS(form[field('actDate')] || null)}
            </summary>
          )}
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={6} md={2} className={classes.textRowLabelSpacer}>
          <label>ACT Score:</label>
        </Grid>
        <Grid item xs={6} md={2} className={classes.textRowLabelSpacer}>
          <label>ACT Test Date:</label>
        </Grid>
        <Grid item xs={6} md={4} className={classes.rowSpacer}>
          {dateUtcToS(form[field('actDate')] || null)}
        </Grid>
      </Grid>

      <Grid container direction="row" alignItems="center" className={classes.unprintedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>FAFSA Completed:</label>
        </Grid>
        <Grid item xs={12} md={6} className={classes.rowSpacer} style={{ marginTop: 8, marginBottom: 8 }}>
          <FormControl fullWidth>
            <RadioGroup
              row
              aria-label="FAFSA completed?"
              name="fafsa-completed"
              defaultValue={form[field('fafsaCompleted')]}
              value={form[field('fafsaCompleted')]}
              onChange={(event) => setForm({ ...form, [field('fafsaCompleted')]: event.target.value })}
              disabled={disabled}
            >
              <FormControlLabel
                value="yes"
                control={<Radio color="default" disabled={disabled} />}
                label={<span className={classes.radioLabel}>Yes</span>}
              />
              <FormControlLabel
                value="no"
                control={<Radio color="default" disabled={disabled} />}
                label={<span className={classes.radioLabel}>No</span>}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>FAFSA Completed?</label>
        </Grid>
        <Grid item xs={false} md={3} lg={false} />
        <Grid item xs={6} md={6} className={classes.rowSpacer}>
          {form[field('fafsaCompleted')]}
        </Grid>
      </Grid>
      <Grid container direction="row" alignItems="center" className={classes.unprintedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>Student Aid Index:</label>
        </Grid>
        <Grid item xs={12} md={6} className={classes.rowSpacer} style={{ marginTop: 16, marginBottom: 16 }}>
          <FormControl fullWidth>
            <TextField
              id="student-aid-index"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form[field('studentAidIndex')]}
              onChange={(event) => setForm({ ...form, [field('studentAidIndex')]: event.target.value })}
              inputProps={{ maxLength: 50, classes: { input: classes.textField } }}
              disabled={disabled}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>Student Aid Index:</label>
        </Grid>
        <Grid item xs={6} sm={4} className={classes.rowSpacer}>
          {form[field('studentAidIndex')]}
        </Grid>
      </Grid>

      <Grid container direction="row" alignItems="center" className={classes.unprintedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>
            List any certifications you have acquired <br /> (i.e. CNA, Culinary, Forklift, OSHA, Fastlane, etc.):
          </label>
        </Grid>
        <Grid item xs={12} md={6} className={classes.rowSpacer} style={{ marginTop: 16, marginBottom: 16 }}>
          <FormControl fullWidth>
            <TextField
              id="certifications"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form[field('certifications')]}
              onChange={(event) => setForm({ ...form, [field('certifications')]: event.target.value })}
              inputProps={{ maxLength: 50, classes: { input: classes.textField } }}
              disabled={disabled}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>List any certifications you have acquired:</label>
        </Grid>
        <Grid item xs={6} sm={4} className={classes.rowSpacer}>
          {form[field('certifications')]}
        </Grid>
      </Grid>

      <Grid container direction="row" alignItems="center" className={classes.unprintedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>Have you attended Millard North High School? If yes, list class and grade received:</label>
        </Grid>
        <Grid item xs={12} md={6} className={classes.rowSpacer} style={{ marginTop: 16, marginBottom: 16 }}>
          <FormControl fullWidth>
            <TextField
              id="intended-major"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form[field('gradeAtMillardNorthHighSchool')]}
              onChange={(event) => setForm({ ...form, [field('gradeAtMillardNorthHighSchool')]: event.target.value })}
              inputProps={{ maxLength: 50, classes: { input: classes.textField } }}
              disabled={disabled}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>Have you attended Millard North High School? If yes, list class and grade received:</label>
        </Grid>
        <Grid item xs={6} sm={4} className={classes.rowSpacer}>
          {form[field('gradeAtMillardNorthHighSchool')]}
        </Grid>
      </Grid>

      <Grid container direction="row" alignItems="center" className={classes.unprintedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>Name of the school you plan to attend:</label>
        </Grid>
        <Grid item xs={12} md={6} className={classes.rowSpacer} style={{ marginTop: 8, marginBottom: 8 }}>
          <FormControl fullWidth>
            <TextField
              id="schoolName"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form[field('schoolName')]}
              onChange={(event) => setForm({ ...form, [field('schoolName')]: event.target.value })}
              inputProps={{ maxLength: 50, classes: { input: classes.textField } }}
              disabled={disabled}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>Name of the school you plan to attend:</label>
        </Grid>
        <Grid item xs={6} sm={4} className={classes.rowSpacer}>
          {form[field('schoolName')]}
        </Grid>
      </Grid>

      <Grid container direction="row" alignItems="center" className={classes.unprintedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>Intended Major:</label>
        </Grid>
        <Grid item xs={12} md={6} className={classes.rowSpacer} style={{ marginTop: 16, marginBottom: 16 }}>
          <FormControl fullWidth>
            <TextField
              id="intended-major"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form[field('intendedMajor')]}
              onChange={(event) => setForm({ ...form, [field('intendedMajor')]: event.target.value })}
              inputProps={{ maxLength: 50, classes: { input: classes.textField } }}
              disabled={disabled}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>Intended Major:</label>
        </Grid>
        <Grid item xs={6} sm={4} className={classes.rowSpacer}>
          {form[field('intendedMajor')]}
        </Grid>
      </Grid>

      <Grid container direction="row" alignItems="center" className={classes.unprintedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>Acceptance Status: Have you been accepted?</label>
        </Grid>
        <Grid item xs={12} md={6} className={classes.rowSpacer} style={{ marginTop: 8, marginBottom: 8 }}>
          <FormControl fullWidth>
            <RadioGroup
              row
              aria-label="Acceptance Status"
              name="acceptanceStatus"
              value={form[field('acceptanceStatus')]}
              onChange={(event) => setForm({ ...form, [field('acceptanceStatus')]: event.target.value })}
              disabled={disabled}
            >
              <FormControlLabel
                value="yes"
                control={<Radio color="default" disabled={disabled} />}
                label={<span className={classes.radioLabel}>Yes</span>}
              />
              <FormControlLabel
                value="no"
                control={<Radio color="default" disabled={disabled} />}
                label={<span className={classes.radioLabel}>No</span>}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>Acceptance Status: Have you been accepted?</label>
        </Grid>
        <Grid item xs={false} md={3} lg={false} />
        <Grid item xs={6} md={6} className={classes.rowSpacer}>
          {form[field('acceptanceStatus')]}
        </Grid>
      </Grid>

      <Grid container direction="row" alignItems="center" className={classes.unprintedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>Housing Plan:</label>
        </Grid>
        <Grid item xs={12} md={6} className={classes.rowSpacer} style={{ marginTop: 16, marginBottom: 16 }}>
          <FormControl fullWidth variant="outlined" size="small">
            <Select
              id="housing-plan"
              value={form[field('housingPlan')]}
              onChange={(event) => setForm({ ...form, [field('housingPlan')]: event.target.value })}
              disabled={disabled}
              displayEmpty
            >
              <MenuItem value="" disabled>
                <em>Select Housing Plan</em>
              </MenuItem>
              {HOUSING_PLAN_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>Housing Plan:</label>
        </Grid>
        <Grid item xs={6} sm={4} className={classes.rowSpacer}>
          {form[field('housingPlan')]}
        </Grid>
      </Grid>

      <Grid container direction="row" alignItems="center" className={classes.unprintedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>Do you plan to have a part-time job while you are in school?</label>
        </Grid>
        <Grid item xs={12} md={6} className={classes.rowSpacer} style={{ marginTop: 8, marginBottom: 8 }}>
          <FormControl fullWidth>
            <RadioGroup
              row
              aria-label="Do you plan to have a part-time job while you are in school"
              name="partTimeJobWhileInSchool"
              value={form[field('partTimeJobWhileInSchool')]}
              onChange={(event) => setForm({ ...form, [field('partTimeJobWhileInSchool')]: event.target.value })}
              disabled={disabled}
            >
              <FormControlLabel
                value="yes"
                control={<Radio color="default" disabled={disabled} />}
                label={<span className={classes.radioLabel}>Yes</span>}
              />
              <FormControlLabel
                value="no"
                control={<Radio color="default" disabled={disabled} />}
                label={<span className={classes.radioLabel}>No</span>}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>Do you plan to have a part-time job while you are in school?</label>
        </Grid>
        <Grid item xs={false} md={3} lg={false} />
        <Grid item xs={6} md={6} className={classes.rowSpacer}>
          {form[field('partTimeJobWhileInSchool')]}
        </Grid>
      </Grid>

      <Grid container direction="row" alignItems="center" className={classes.unprintedContent}>
        <Grid item xs={12} md={3} className={classes.textRowLabelSpacer}>
          <label>
            <strong>Outstanding Needs</strong>: Anticipated needs if scholarships are unable to cover your first choice school.
          </label>
        </Grid>
        <Grid item xs={12} md={6} className={classes.rowSpacer} style={{ marginTop: 16, marginBottom: 16 }}>
          <FormControl fullWidth>
            <TextField
              id="act"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form[field('outstandingNeeds')]}
              onChange={(event) => setForm({ ...form, [field('outstandingNeeds')]: event.target.value })}
              inputProps={{ maxLength: 100, classes: { input: classes.textField } }}
              disabled={disabled}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.printedContent}>
        <Grid item xs={6} sm={2} className={classes.textRowLabelSpacer}>
          <label>
            <strong>Outstanding Needs</strong>: Anticipated needs if scholarships are unable to cover your first choice school.
          </label>
        </Grid>
        <Grid item xs={6} sm={4} className={classes.rowSpacer}>
          {form[field('outstandingNeeds')]}
        </Grid>
      </Grid>
    </>
  );
};

Edu.propTypes = {
  form: PropTypes.object.isRequired,
  setForm: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default Edu;
